import React from "react";
import mabAdArrow from "../../assets/images/svg/mab-ad-arrow.svg";

type NextButtonProps = {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
  size?: "sm" | "md";
  className?: string;
  type?: "button" | "submit";
};

const sizeMap = {
  md: { padding: "12px 24px", fontSize: "16px", icon: 24 },
  sm: { padding: "12px 24px", fontSize: "16px", icon: 24 },
} as const;

const NextButton: React.FC<NextButtonProps> = ({
  label = "Next",
  onClick,
  disabled = false,
  size = "md",
  className = "",
  type = "button",
}) => {
  const sizing = sizeMap[size];

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-[999px] bg-white text-[#020202] font-semibold shadow-[0_8px_24px_rgba(0,0,0,0.35)]  transition-transform disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      style={{ padding: sizing.padding, fontSize: sizing.fontSize }}
    >
      {label}
      <img
        src={mabAdArrow}
        alt="Next"
        className="w-auto h-auto"
        style={{ width: sizing.icon, height: sizing.icon }}
      />
    </button>
  );
};

export default NextButton;
